import React from "react";
import { withStyles } from "@material-ui/core";
import { getDataWithQueryString } from "../../../../api/componentAPIs";
import { compose } from "recompose";
import Events from "../../../../utilities/EventEmitter";
import { withUserProfile } from "../../../../userProfile/userProfileContext";

const styles = (theme) => ({
  kpiContainer: {
    height: "100%",
    width: "100%",
    display: "flex",
  },
  kpiHeader: {
    display: "flex",
    fontSize: "16px",
    width: "60px",
    height: "100%",
    textAlign: "center",
    color: theme.HeaderSelectedText,
    fontWeight: 600,
    alignItems: "center",
    justifyContent: "center",
  },
  kpiContent: {
    display: "flex",
    height: "100%",
    width: "calc(100% - 60px)",
    alignItems: "center",
    overflow: "auto",
    whiteSpace: "nowrap",
  },
  kpiValueContainerGroup: {
    display: "inline-block",
    paddingLeft: "20px",
    paddingRight: "20px",
  },
  kpiName: {
    fontSize: "14px",
    color: theme.KPI.KPILabel,
  },
  kpiValue: {
    fontSize: "16px",
    fontWeight: "bold",
    textAlign: "center",
    color: theme.KPI.KPISingleValue,
  },
  kpiGoal: {
    color: theme.KPI.KPIGoalValue,
  },
  kpiValueNormal: {
    color: theme.KPI.KPILabel,
  },
  kpiValuePositive: {
    color: theme.KPI.KPIPositive,
  },
  kpiValueNegative: {
    color: theme.KPI.KPINegative,
  },
  kpiDivider: {
    borderLeft: `3px solid ${theme.KPI.KPIDivider}`,
  },
});

class KPIPanel extends React.Component {
  constructor(props) {
    super(props);
    this.height = 0;
    this.state = {
      routeComplianceKPIData: [],
    };
  }

  componentDidMount() {
    Events.on("hideKpi", this.hideKpi);
    Events.on("showKpi", this.showKpi);
    Events.on("getRouteComplianceKPI", this.getRouteComplianceKPI);
  }

  componentWillUnmount() {
    Events.removeListener("hideKpi", this.hideKpi);
    Events.removeListener("showKpi", this.showKpi);
    Events.removeListener("getRouteComplianceKPI", this.getRouteComplianceKPI);
  }

  hideKpi = () => {
    this.height = this.props.glContainer.height;
    this.props.glContainer.setSize(this.props.glContainer.width, 1);
    this.props.glContainer.hide();
  };

  showKpi = () => {
    this.props.glContainer.show();
    this.props.glContainer.setSize(this.props.glContainer.width, this.height);
  };

  updateRouteComplianceKPIData(data) {
    const KPIGroup = {};
    data.map((kpi) => {
      if (KPIGroup[kpi.kpiGroup] == undefined) {
        KPIGroup[kpi.kpiGroup] = [kpi];
      } else {
        KPIGroup[kpi.kpiGroup].push(kpi);
      }
    });
    this.setState({ routeComplianceKPIData: Object.values(KPIGroup) });
  }

  getRouteComplianceKPI = (dispatchDate, terminalCode) => {
    getDataWithQueryString(
      "GetRouteComplianceKPI",
      `dispatchDate=${dispatchDate}&terminalCode=${terminalCode}`
    ).then(
      (response) => {
        if (response.status >= 200 && response.status <= 400) {
          this.updateRouteComplianceKPIData(response.data);
        } else {
          this.updateRouteComplianceKPIData([]);
        }
      },
      (error) => {
        this.updateRouteComplianceKPIData([]);
      }
    );
  };

  render() {
    const { classes } = this.props;
    return (
      <div className={classes.kpiContainer}>
        <div className={classes.kpiHeader}>KPI</div>
        <div className={`${classes.kpiContent} KPIContent`}>
          {this.state.routeComplianceKPIData.map((kpis, index) => (
            <div className={classes.kpiDivider} key={`KPI${index}`}>
              {kpis.map((kpi) => (
                <div
                  className={classes.kpiValueContainerGroup}
                  key={kpi.kpiName}
                >
                  <div
                    className={`${classes.kpiValue} ${
                      classes[getKPIComplianceClass(kpi)]
                    }`}
                  >
                    {`${kpi.value || 0} `}
                    <span
                      className={`${classes.kpiGoal} ${
                        kpi.hideGoalValue ? "hide" : ""
                      }`}
                    >
                      / {kpi.goal || 0}
                    </span>
                  </div>
                  <div className={classes.kpiName}>{kpi.kpiName}</div>
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
    );
  }
}

//Calculate KPI compliance value and return class for KPI based on that
const getKPIComplianceClass = (kpi) => {
  if (kpi.complianceFormula !== null) {
    if (kpi.complianceFormula === "G") {
      if (parseFloat(kpi.value) >= parseFloat(kpi.goal)) {
        return "kpiValuePositive";
      } else return "kpiValueNegative";
    } else {
      if (parseFloat(kpi.value) > parseFloat(kpi.goal)) {
        return "kpiValueNegative";
      } else return "kpiValuePositive";
    }
  }
  return "kpiValueNormal";
};

export default compose(withStyles(styles), withUserProfile)(KPIPanel);
